import React from 'react';
import styled from 'styled-components';

import { lightGrey2Color } from 'js/config/style';
import PencilIcon from 'js/components/core/Icons/PencilIcon';

const Container = styled.div`
  text-align: center;
  display: grid;
  justify-content: center;
  align-content: center;
`;

export default ({ onClick }) => (
  <Container onClick={onClick}>
    <PencilIcon color={lightGrey2Color} />
  </Container>
);
